import React, { ReactElement, useEffect } from 'react';
import { Route, RouteComponentProps, Switch, withRouter } from 'react-router-dom';
import ErrorPage from '../../shared/components/error-page';
import { PrivateModule, singlePage } from '../../shared/data-models/private-module';
import CanLoad from '../../shared/hoc/can-load';
import { adminAccountList } from '../shared/data-models/home-data';
import SinglePage from './single-page';

function PrivatePage(props: RouteComponentProps): ReactElement {
    const {
        match,
        history,
        location: { pathname },
    } = props;

    useEffect(() => {
        const pageName = pathname.split('/')[2];
        const adminAccount = sessionStorage.getItem('adminAccount');
        if (!pageName && !(adminAccount && adminAccountList.includes(adminAccount))) {
            history.replace('/login');
        }
    });

    const loader: { [P in PrivateModule]: any } = {
        january: React.lazy(() => import('../../january/january')),
        february: React.lazy(() => import('../../february/february')),
        march: React.lazy(() => import('../../march/march')),
        april: React.lazy(() => import('../../april/april')),
        may: React.lazy(() => import('../../may/may')),
        june: React.lazy(() => import('../../june/june')),
        july: React.lazy(() => import('../../july/july')),
        august: React.lazy(() => import('../../august/august')),
        september: React.lazy(() => import('../../september/september')),
        october: React.lazy(() => import('../../october/october')),
        november: React.lazy(() => import('../../november/november')),
        december: React.lazy(() => import('../../december/december')),
    };

    const module = match.url.replace(/\//g, '') as PrivateModule;
    const content = <CanLoad content={loader[module]} />;
    return (
        // <Header /> 这里可以配置 header
        <Switch>
            <Route exact path={match.path}>
                {content}
            </Route>
            <Route path={singlePage[module].map((item: string): string => `${match.path}/${item}`)}>
                <SinglePage />
            </Route>
            <Route path={`${match.path}/*`}>
                <ErrorPage code={404} />
            </Route>
        </Switch>
    );
}

// 因当前文件是私有文件，需要验证一些权限，所以在此可以配置一下 authGuard
export default withRouter(PrivatePage);
